module.exports = __webpack_public_path__ + "img/page6-icon2.bb3d31a0.png";